import buzzwordsData from "../data/buzzWords.json";

class TrieNode {
  children: Record<string, TrieNode> = {};
  wordEnd: boolean = false;
  word?: string;
  failLink?: TrieNode;
}

class AhoCorasick {
  private root: TrieNode;

  constructor(words: string[]) {
    this.root = new TrieNode();
    this.buildTrie(words);
    this.buildFailLinks();
  }

  // Step 1: Build the Trie
  private buildTrie(words: string[]) {
    for (const word of words) {
      let node = this.root;
      for (const char of word) {
        if (!node.children[char]) {
          node.children[char] = new TrieNode();
        }
        node = node.children[char];
      }
      node.wordEnd = true;
      node.word = word; // Store the full word at the end
    }
  }

  // Step 2: Build Failure Links for Efficient Search
  private buildFailLinks() {
    const queue: TrieNode[] = [];

    // First level links to root
    for (const key in this.root.children) {
      const child = this.root.children[key];
      child.failLink = this.root;
      queue.push(child);
    }

    while (queue.length > 0) {
      const node = queue.shift()!;
      for (const key in node.children) {
        const child = node.children[key];
        let fail = node.failLink;

        while (fail && !fail.children[key]) {
          fail = fail.failLink!;
        }

        child.failLink = fail ? fail.children[key] : this.root;
        queue.push(child);
      }
    }
  }

  // Step 3: Search the Text for Matches
  search(text: string): string[] {
    let node = this.root;
    const foundWords = new Set<string>();

    for (const char of text) {
      while (node && !node.children[char]) {
        node = node.failLink!;
      }

      if (!node) {
        node = this.root;
        continue;
      }

      node = node.children[char];

      let temp: TrieNode | undefined = node;
      while (temp) {
        if (temp.wordEnd) {
          foundWords.add(temp.word!);
        }
        temp = temp.failLink;
      }
    }
    return Array.from(foundWords);
  }
}

const buzzwords: string[] = buzzwordsData.buzzwords;

const matcher = new AhoCorasick(buzzwords);
export default matcher;
// console.log(matcher.search(text));
// Output: [ 'highly adaptable', 'proactive', 'team player', 'results-oriented' ]
